import React from 'react';
import ProfileGenerique from '../profile/ProfileGenerique';

export default function ProfileFinancier() {
    return (
        <ProfileGenerique 
            role="financier" 
            title="💰 Mon profil financier"
            color="from-emerald-600 to-teal-600"
        />
    );
}